import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=b7ccf780&scoped=true"
import script from "./NewsletterForm.vue?vue&type=script&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&lang=js"
import style0 from "./NewsletterForm.vue?vue&type=style&index=0&id=b7ccf780&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ccf780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7ccf780')) {
      api.createRecord('b7ccf780', component.options)
    } else {
      api.reload('b7ccf780', component.options)
    }
    module.hot.accept("./NewsletterForm.vue?vue&type=template&id=b7ccf780&scoped=true", function () {
      api.rerender('b7ccf780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/controlPanel/landingPage/NewsletterForm.vue"
export default component.exports